import { render, staticRenderFns } from "./option-child-manage-goods.vue?vue&type=template&id=f437aafa"
import script from "./option-child-manage-goods.vue?vue&type=script&lang=js"
export * from "./option-child-manage-goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports